module.exports = __webpack_public_path__ + "img/T6-D-rc_8.e4f80d34.png";